import React, { useState, useEffect } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import Slider from "react-slick";
import { Element, scroller } from 'react-scroll';
import HTML5Player from '../components/HTML5Player';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Heading, LineHeading, StyledNextArrow, StyledPrevArrow } from './MusicAppreciation';
import { 
  Wrapper, StyledSection, QuoteWrapper, GuidePlayer, GuideBox,
  GuideInfo, GuideAvatar, GuideInfoContent, GuideAvatarRemark,
  GuidePlay, GridBottomDecoWrapper, GridBottomDeco,
  StyledSliderWrapper,
  OtherCelebrityAvatar as OtherGenre,
  StyledLeftHeading, PlayingLabel, StyledPlay, StyledPause,
  AvatarInfo, SongRow, SongInfo, SongWrapper
} from './CelebrityDetail';
import { timestemp, mode, unsupported, dataLayer } from '../App';

const urlParams = new URLSearchParams(window.location.search);
const GenreId = parseInt(urlParams.get('genre'));

const settings = {
  slidesToShow: 4,
  className: "center",
  nextArrow: <StyledNextArrow />,
  prevArrow: <StyledPrevArrow />,
  infinite: false,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        className: "center",
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        speed: 500,
        arrows: false
      }
    }
  ]
};

const StyledWrapper = styled(Wrapper)`
  .key-visual {
    max-width: 1000px;
    margin: auto;
  }
`;

const StyledHeading = styled(Heading)`
  font-size: 20px;
  padding-bottom: 0;
`;

const StyledLineHeading = styled(LineHeading)`
  font-size: 16px;
  padding-top: 4px;
  width: calc(100% - 32px);
  max-width: 1000px;
  margin: auto;

  &:before, &:after{
    height: 3px;
  }


  @media only screen and (min-width: 700px) {
    font-size: 32px;
    text-align: center;
  }
`;

const InfoBox = styled.div`
  width: 100%;
  line-height: 1.5;
  color: white;
`;

const Remark = styled.div`
  text-align: center;
  padding-bottom: 30px;
`;

const StyledHTML5Player = styled(HTML5Player)`
  display: block;
`;

const getData = async () => {
  let data = [];
  try {
    const response = await axios.get(`${process.env.REACT_APP_BUILD_URL}/data${mode !== 'production' ? '.uat' : ''}.json?t=${timestemp}`);
    if(response.status === 200) {
      data = response.data;
    }

    return data;
  } catch(err) {
    console.log(err);
  }
}

const GenreDetail = ({ cslExclusive24bit }) => {
  const [pageData, setPageData] = useState(null);
  const [genreData, setGenreData] = useState([]);
  const [otherGenreData, setoOtherGenreData] = useState([]);
  const [celebrityData, setCelebrityData] = useState([]);
  const [songData, setSongData] = useState([]);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentSongId, setCurrentSongId] = useState(-1);
  const [currentSong, setCurrentSong] = useState(null);
  const [cuepointsData, setCuepoints] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const data = await getData();
      const genre = data.genre.filter(item => item.id === GenreId);
      const otherGenre = data.genre.filter(item => item.id !== GenreId);
      const songs = data.songs.filter(item => item.genreid === GenreId).sort((a, b) => b.genreorderid - a.genreorderid);
      const celebrity_ids = songs.map(song => song.celebrityid);
      const celebrity = data.celebrities.filter(item => celebrity_ids.indexOf(item.id) !== -1);
      const songsWithPlaying = songs.map(item => ({ ...item, playing: false }));
      setPageData(data);
      setGenreData(genre);
      setoOtherGenreData(otherGenre);
      setCurrentImage({
        mobile: genre[0].fallbackimagemobile,
        desktop: genre[0].fallbackimagedesktop
      });
      setSongData(songsWithPlaying);
      setCelebrityData(celebrity);
    }

    if (!pageData) {
      fetchData();
    }
  }, [pageData, currentSongId]);

  return (
    <StyledWrapper>
      <Header isRedirect />
      {!!currentImage && (
        <div className="key-visual">
          {typeof currentImage.mobile !== 'undefined' ? <img className="mobile" src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/genre' : 'prod/genre'}/${currentImage.mobile}`} alt="" width="100%" /> : null}
          {typeof currentImage.desktop !== 'undefined' ? <img className="desktop" src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/genre' : 'prod/genre'}/${currentImage.desktop}`} alt="" width="100%" /> : null}
        </div>
      )}
       <StyledSection bg={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2.jpg`} bgd={`${process.env.REACT_APP_BUILD_URL}/images/site/home/bg2_d.jpg`} autoHeight>
        {Array.isArray(genreData) && genreData.map((item, index) => (
          <InfoBox key={index}>
            <br />
            {!!item.quote && item.quote !== '' && <QuoteWrapper>{item.quote}</QuoteWrapper>}
            <StyledLineHeading>{item.name}</StyledLineHeading>
            <StyledHeading>嚴選試聽 24 bit</StyledHeading>
            <Remark>建議使用耳機全面感受24bit帶來之細緻音質</Remark>
          </InfoBox>
        ))}
        <br />

      <Element name="player"><div></div></Element>
      {
        !!currentSong && (
          <GuidePlayer>
            <img className="top-deco" src={`${process.env.REACT_APP_BUILD_URL}/images/site/player/player1.png`} alt="" width="100%" />
            <GuideBox>
              <GuideInfo>
                <GuideAvatar>
                  {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/${celebrityData[0].avatar}`} alt="" width="100%" /> */}
                  <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/audio' : 'prod/audio'}/${currentSong.cover}`} alt="" width="100%" />
                </GuideAvatar>
                <GuideInfoContent>
                  <b>{currentSong.name}</b>
                  <div className="guide-album-info">{currentSong.artist} {currentSong.album}</div>
                  <br />
                  {Array.isArray(celebrityData) && celebrityData.filter(item => item.id === currentSong.celebrityid).map((item, index) => (
                    <GuideAvatarRemark key={index}>音樂導賞由<span>{item.name}</span>提供</GuideAvatarRemark>
                  ))}
                </GuideInfoContent>
                <GuidePlay onClick={() => {
                  const songsWithPlaying = songData.map((song, index) => ({ ...song,  playing: song.id === currentSong.id ? !song.playing : false }));
                  const currentSongsWithPlaying = songsWithPlaying.filter(song => parseInt(song.id) === parseInt(currentSong.id));
                  const cuepoints = pageData.cuepoints.filter(point => parseInt(point.songid) === parseInt(currentSong.id));
                  setCurrentSongId(currentSong.id);
                  setCurrentSong(currentSongsWithPlaying[0]);
                  setSongData(songsWithPlaying);
                  setCuepoints(cuepoints);
                }}>
                  {!currentSong.playing ? <StyledPlay /> : <StyledPause />}
                </GuidePlay>
              </GuideInfo>
              <StyledHTML5Player
                cuePoints={cuepointsData}
                pageData={pageData.genre.filter(genre => genre.id === currentSong.genreid)[0]}
                currentSongData={currentSong}
                songUrl={currentSong.filename}
                playing={currentSong.playing}
                audioType="genres"
                hidden={currentSong.id !== currentSongId || currentSongId === -1}
              />
            </GuideBox>
            <GridBottomDecoWrapper>
              <GridBottomDeco />
            </GridBottomDecoWrapper>
          </GuidePlayer>
        )
      }
      {/* <StyledLeftHeading>嚴選試聽 24 bit</StyledLeftHeading> */}
      {Array.isArray(songData) && songData.map((item, index) => (
        <SongWrapper key={index}>
          <SongRow>
            <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/audio' : 'prod/audio'}/${item.cover}`} alt="" width="70" />
            <SongInfo>
              <b>{item.name}</b>
              <div className="album-info">
                <span>{item.artist}</span>
                <span>{item.album}</span>
              </div>
            </SongInfo>
            <div onClick={() => {
              if (!!unsupported) {
                alert('unsupported');
              } else {
                const songsWithPlaying = songData.map((song, index) => ({ ...song,  playing: song.id === item.id ? !song.playing : false }));
                const currentSongsWithPlaying = songsWithPlaying.filter(song => parseInt(song.id) === parseInt(item.id));
                const cuepoints = pageData.cuepoints.filter(point => parseInt(point.songid) === item.id);
                const genreName = pageData.genre.filter(genre => genre.id === item.genreid)[0].name;
                setCurrentSongId(item.id);
                setSongData(songsWithPlaying);
                setCurrentSong(currentSongsWithPlaying[0]);
                setCuepoints(cuepoints);
                dataLayer.push({ event: 'CodeAudioPlayerEvent', eventAction: 'genre/play_song', eventLabel: `${genreName}/${item.name}` });

                scroller.scrollTo('player', {
                  smooth: "easeInOutQuint",
                  offset: -90
                });
              }
            }}>
              {
                !item.playing ? 
                  <StyledPlay /> :
                  <PlayingLabel>播放中</PlayingLabel>
              }
            </div>
          </SongRow>
        </SongWrapper>
      ))}
      <StyledLeftHeading>更多音樂分類</StyledLeftHeading>
      <div>

      <StyledSliderWrapper>
        <Slider {...settings}>
        {Array.isArray(otherGenreData) && otherGenreData.map((item, index) => (
          <OtherGenre
            key={index}
            href={`${process.env.REACT_APP_BASE_URL}?genre=${item.id}`}
            onClick={() => {
              const genreName = genreData[0].name;
              dataLayer.push({ event: 'CodeOtherGenresEvent', eventAction: 'genres/click_other_celebrities', eventLabel: `${genreName}/${item.name}` });
            }}
          >
            <div className="avatar-bg">
              <img src={`${process.env.REACT_APP_BUILD_URL}/${mode !== 'production' ? 'uat/genre' : 'prod/genre'}/${item.cover}`} alt="" width="100%" />
              {/* <img src={`${process.env.REACT_APP_BUILD_URL}/images/site/artist1.jpg`} alt="" width="100%" /> */}
            </div>
            <AvatarInfo>
              <div className="name"><b>{item.name}</b></div>
              <div className="info">{item.title}</div>
            </AvatarInfo>
          </OtherGenre>
        ))}
        </Slider>
      </StyledSliderWrapper>
      </div>
      <br />
      <br />
      </StyledSection>
      <Footer cslExclusive24bit={cslExclusive24bit} />
    </StyledWrapper>
  );
}

export default GenreDetail;
